/* import __COLOCATED_TEMPLATE__ from './feature-divider-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();